var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSumInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.5,
    d: "M.75 17.25a6.752 6.752 0 0 1 9.4-6.208M3.945 2.781a6.852 6.852 0 0 0 7.642 1.536"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.5,
    d: "M7.5.75A4.125 4.125 0 1 1 7.5 9a4.125 4.125 0 0 1 0-8.25z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3DC1D3",
    strokeWidth: 1.5,
    d: "M17.25 11.25a6 6 0 1 1 0 12 6 6 0 0 1 0-12zM17.25 20.25v-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3DC1D3",
    strokeWidth: 1.5,
    d: "M17.25 14.25a.375.375 0 1 0 .002 0h-.002"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSumInfo);
export default __webpack_public_path__ + "static/media/sum-info.21f9aa0ca3314579ead34fb12465722b.svg";
export { ForwardRef as ReactComponent };